import api from "./apiMethods";
import { getCookie } from '../utils/CookiesUtil';

const { REACT_APP_API_URL } = process.env;

export const getGuidesInMatriz = async () => {
  
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/guides-in-matriz`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
}


export const getGuidesInBatch = async (idBatch) => {

  const payload = {
    id_batch: idBatch
  };
  
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/batchs/guides-in-batch`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getUnassignedRoutes = async () => {
  
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get_unassigned_routes`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getGuidesInMatrizBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-guides-in-matriz`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  // Solo agregar data/body si zoneIds tiene valor
  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const getUnassignedRoutesBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-unassigned-routes`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  // Solo agregar data/body si zoneIds tiene valor
  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const getDeliveryGuides = async () => {
  
  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/get-guides-orders`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getDeliveryGuidesBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-guides-orders`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const assignGuidesToDeliveryMan = async (nameDeliveryMan, idsGuides) => {
  
  const payload = {
    name_delivery_man: nameDeliveryMan,
    list_id_guides: idsGuides,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/create-delivery-route`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const assignGuidesToDeliveryManBySuperadmin = async (nameDeliveryMan, idsGuides, idZone) => {
  
  const payload = {
    name_delivery_man: nameDeliveryMan,
    list_id_guides: idsGuides,
    id_zone: idZone,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/create-delivery-route`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const assignGuidesLocation = async (idRecipient, latitude, longitude) => {
  
  const payload = {
    location_type: "recipient",
    id_recipient: idRecipient,
    latitude: latitude,
    longitude: longitude,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/update-lat-long-coordinates`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);
};


export const deliverGuide = async (idGuide, idBatch) => {
  
  const payload = {
    id_guide: idGuide,
    id_batch: idBatch,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/change-package-status`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const generateDailyReport = async () => {
  
  const payload = {
    start_date: "2024-01-01 10:00:00", 
    end_date: "2024-02-01 10:00:00" 
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/extras/create-daily-report`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const dailyReportExist = async () => {
  
  const payload = {
    //"start_date": "2024-01-01 10:00:00",
    //"end_date": "2024-02-01 10:00:00"
  };

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/extras/exist-daily-report`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const trackPackage = async (trackingCode) => {
  
  const payload = {
    tracking_code: trackingCode,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/get-details-guide`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const cancelGuide = async (trackingCode, cancellationReason) => {
  
  const payload = {
    tracking_code: trackingCode,
    cancellation_reason: cancellationReason,
  };

  const request = {
    method: "PUT",
    url: `${REACT_APP_API_URL}/admin/cancel-guide-by-admin`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const setGuideIncidence = async (trackingCode, incidenceReason) => {

  const payload = {
    tracking_code: trackingCode,
    incidence_reason: incidenceReason,
  };

  const request = {
    method: "PUT",
    url: `${REACT_APP_API_URL}/admin/set-guide-incidence-by-admin`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getGuidesInIncidence = async () => {

  const request = {
    method: "GET",
    url: `${REACT_APP_API_URL}/admin/guides-in-incidence`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getGuidesInIncidenceBySuperadmin = async (zoneIds = null) => {
  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/superadmin/get-guides-in-incidence`,
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  if (zoneIds && Array.isArray(zoneIds) && zoneIds.length > 0) {
    const payload = { zones: zoneIds };
    request.data = payload;
    request.body = JSON.stringify(payload);
  }

  return api(request);
};

export const downloadGuidePDFCarta = async (trackingCode) => {
  
  const payload = {
    tracking_code: trackingCode,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/download-guide-pdf-carta`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const downloadGuidePDFTermica = async (trackingCode) => {
  
  const payload = {
    tracking_code: trackingCode,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/download-guide-pdf-termica`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const getGuideEvidence = async (trackingCode) => {
  
  const payload = {
    tracking_code: trackingCode,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/get-guide-evidence`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};

export const downloadGuidePDF = async (trackingCode) => {
  
  const payload = {
    tracking_code: trackingCode,
  };

  const request = {
    method: "POST",
    url: `${REACT_APP_API_URL}/admin/download-guide-pdf`,
    data: payload,
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      "auth_token": getCookie('accessToken'),
    },
  };

  return api(request);

};